module.exports = __webpack_public_path__ + "static/media/TLMS.78269ad3.jpeg";